export const RECEIVE_AUTHENTICATED_USER = 'RECEIVE_AUTHENTICATED_USER';
export const RECEIVE_SIGN_OUT_USER = 'RECEIVE_SIGN_OUT_USER';

export const REQUEST_PROJECTS = 'REQUEST_PROJECTS';
export const RECEIVE_PROJECTS = 'RECEIVE_PROJECTS';
export const PROJECT_HAS_BEEN_CREATED = 'PROJECT_HAS_BEEN_CREATED ';
export const PROJECT_HAS_BEEN_UPDATED = 'PROJECT_HAS_BEEN_UPDATED ';
export const PROJECT_HAS_BEEN_DELETED = 'PROJECT_HAS_BEEN_DELETED';

export const REQUEST_TASKS = 'REQUEST_TASKS';
export const RECEIVE_TASKS = 'RECEIVE_TASKS';
export const TASK_HAS_BEEN_CREATED = 'TASK_HAS_BEEN_CREATED ';

export const REQUEST_USER_TASKS = 'REQUEST_USER_TASKS';
export const RECEIVE_USER_TASKS = 'RECEIVE_USER_TASKS';
export const RECEIVE_SPECIFIC_USER_TASKS = 'RECEIVE_SPECIFIC_USER_TASKS';

export const APPEND_HIDDEN_UID = 'APPEND_HIDDEN_UID';
export const REMOVE_HIDDEN_UID = 'REMOVE_HIDDEN_UID';
export const RESTORE_HIDDEN_UIDS = 'RESTORE_HIDDEN_UIDS';



/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/